import { useEffect, useState } from "react";
import axios from "axios";
import { TESTIMONIALS } from "@/data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function useTestimonials() {
  const [items, setItems] = useState(TESTIMONIALS);

  useEffect(() => {
    axios
      .get(`${API}/testimonials`)
      .then((r) => {
        if (Array.isArray(r.data) && r.data.length > 0) setItems(r.data);
      })
      .catch(() => {});
  }, []);

  return items;
}
